

















































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  UserApi, User, MarketsApi, Settings, SettingsApi, PartnersApi,
} from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import AppModule from '@/store/modules/app';
import PartnerUtil from '@/util/PartnerUtil';
import PartnersList from '@/components/Table/PartnersList/index.vue';
import Searchfield from '@/components/Form/Searchfield/index.vue';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import DownloadIcon from '@/components/Icons/DownloadIcon/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
import RestaurantPartnersDelete from '@/components/Modal/RestaurantPartnersDelete/index.vue';
import PageTitle from '@/components/PageTitle/index.vue';
import SystemModule from '@/store/modules/system';
import MarketUtil from '@/util/MarketUtil';
import Format from '@/util/Format';
import UnitsUtil from '@/util/UnitUtil';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';
import { FWAccessControl } from '../../util/AccessControlUtil';
import PermissionMixin from '../../mixins/PermissionMixin';

@Component({
  components: {
    PartnersList,
    Searchfield,
    Dropdown,
    DownloadIcon,
    PrimaryButton,
    SecondaryButton,
    PageTitle,
    RestaurantPartnersDelete,
  },
})
export default class Partners extends mixins(PermissionMixin) {
  private search: any = '';

  private searchMarket: any = [];

  private searchScout: any = [];

  private searchStatus: any = [];

  private searchCuisine: any = [];

  private searchType: any = [];

  private marketCheck: string = '';

  private scoutCheck: string = '';

  private statusCheck: string = '';

  private cuisineCheck: string = '';

  private typeCheck: string = '';

  private marketItems: any[] = [];

  private scoutItems: User [] = [];

  private marketsLoaded: boolean = false;

  private scoutsLoaded: boolean = false;

  private errors: string = '';

  private showDeleteIcon: boolean = false;

  private restaurantPartners: any[] = [];

  private dialog: boolean = false;

  public cuisinesArray: Settings [] = [];

  public partnerArr: any[] = [];

  public checkPartnerValue: boolean = false;

  private profileValue: any = {
    deleteProfile: '',
    saving: false,
  }

  private statusItems = [
    {
      text: 'Approved',
      value: 'Approved',
    },
    {
      text: 'In-progress',
      value: 'In-progress',
    },
    {
      text: 'Pending approval',
      value: 'Pending approval',
    },
  ];

  private typeItems = [
    {
      text: 'Restaurant',
      value: 'Restaurant',
    },
    {
      text: 'Foodtruck',
      value: 'Foodtruck',
    },
    {
      text: 'Apron Exchange',
      value: 'Apron Exchange',
    },
  ];

  public addPartner() {
    this.$router.push('/partners/create-partner/');
  }

  public onMarket(data: any) {
    this.updateQuery(JSON.stringify(data), 'market');
  }

  public onScout(data: any) {
    this.updateQuery(JSON.stringify(data), 'scout');
  }

  public onStatus(data: any) {
    this.updateQuery(JSON.stringify(data), 'status');
  }

  public onType(data: any) {
    this.updateQuery(JSON.stringify(data), 'type');
  }

  public onSearch(data: any) {
    this.updateQuery(data, 'search');
  }

  public onCuisine(data: any) {
    this.updateQuery(JSON.stringify(data), 'cuisine');
  }

  public updateQuery(data: any, key: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [key]: data,
      },
    });
  }

  public resetQuery() {
    this.$router.replace({
      query: {},
    });
  }

  public clearSearchAll() {
    this.searchMarket = [];
    this.searchStatus = [];
    this.searchScout = [];
    this.searchCuisine = [];
    this.searchType = [];
    this.marketCheck = '';
    this.scoutCheck = '';
    this.statusCheck = '';
    this.cuisineCheck = '';
    this.typeCheck = '';
    this.resetQuery();
  }

  filteredItems: any = [];

  mounted() {
    if (this.$route.query) {
      const {
        status,
        scout,
        market,
        cuisine,
        type,
        search,
      } = this.$route.query;
      if (status) {
        this.searchStatus = JSON.parse((status as any));
      }
      if (scout) {
        this.searchScout = JSON.parse((scout as any));
      }
      if (market) {
        this.searchMarket = JSON.parse((market as any));
      }
      if (cuisine) {
        this.searchCuisine = JSON.parse((cuisine as any));
      }
      if (type) {
        this.searchType = JSON.parse((type as any));
      }
      if (search !== null) {
        this.search = search;
      }
    }

    this.watchMenuClose('marketSelectRef', () => {
      this.marketCheck = '';
    });
    this.watchMenuClose('scoutSelectRef', () => {
      this.scoutCheck = '';
    });
    this.watchMenuClose('statusSelectRef', () => {
      this.statusCheck = '';
    });
    this.watchMenuClose('cuisineSelectRef', () => {
      this.cuisineCheck = '';
    });
    this.watchMenuClose('typeSelectRef', () => {
      this.typeCheck = '';
    });

    this.getMarkets();
    this.getScouts();
    this.getCuisinesArray();
  }

  private watchMenuClose(refName: string, reset: () => void) {
    this.$watch(
      () => (this.$refs[refName] as any)?.isMenuActive,
      (val: boolean) => {
        if (!val) reset();
      },
    );
  }

  public async getMarkets() {
    try {
      const api = new MarketsApi(AppModule.apiConfig);
      const markets = await api.getMarkets();
      const items = MarketUtil.getMappedMarkets(markets.data);
      this.marketItems = Format.sortedItems(items);
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    } finally {
      this.marketsLoaded = true;
    }
  }

  public async getCuisinesArray() {
    const api = new SettingsApi(AppModule.apiConfig);
    const cuisine: any = await api.getSettings();
    const { cuisineTypes } = cuisine.data;
    const cuisinesArrays = cuisineTypes.sort((a:any, b:any) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
    this.cuisinesArray = MarketUtil.getMappedCusines(cuisinesArrays);
  }

  public async getScouts() {
    try {
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        const api = new UserApi(AppModule.apiConfig);
        const users = await api.getUsers();
        ((this.scoutItems) as any) = UnitsUtil.scoutListFormatted(users.data);
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    } finally {
      this.scoutsLoaded = true;
    }
  }

  get marketItemsFiltered() {
    let filteredItems = this.marketItems;
    if (this.marketCheck) {
      filteredItems = filteredItems.filter(item => Object.values(item)
        .join(',')
        .toLowerCase()
        .includes(this.marketCheck.toLowerCase()));
    }
    return filteredItems;
  }

  get scoutItemsFiltered() {
    let filteredItems = this.scoutItems;
    if (this.scoutCheck) {
      filteredItems = filteredItems.filter(item => Object.values(item)
        .join(',')
        .toLowerCase()
        .includes(this.scoutCheck.toLowerCase()));
    }
    return filteredItems;
  }

  get statusItemsFiltered() {
    let filteredItems = this.statusItems;
    if (this.statusCheck) {
      filteredItems = filteredItems.filter(item => Object.values(item)
        .join(',')
        .toLowerCase()
        .includes(this.statusCheck.toLowerCase()));
    }
    return filteredItems;
  }

  get typeItemsFiltered() {
    let filteredItems = this.typeItems;
    if (this.typeCheck) {
      filteredItems = filteredItems.filter(item => Object.values(item)
        .join(',')
        .toLowerCase()
        .includes(this.typeCheck.toLowerCase()));
    }
    return filteredItems;
  }

  get cuisineItemsFiltered() {
    let filteredItems = this.cuisinesArray;
    if (this.cuisineCheck) {
      filteredItems = filteredItems.filter(item => Object.values(item)
        .join(',')
        .toLowerCase()
        .includes(this.cuisineCheck.toLowerCase()));
    }
    return filteredItems;
  }

  get onBoardingPartnerUser() {
    if (UserModule.currentUser && UserModule.currentRole === 'partner_owner') {
      return UserModule.currentRole;
    }
    return null;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  public async onDeleteRestaurants() {
    this.dialog = true;
  }

  public async onDelete() {
    try {
      this.profileValue.saving = true;
      const api = new PartnersApi(AppModule.apiConfig);
      const user = await api.deletePartners(this.restaurantPartners as any);
      if (user.status === 200) {
        ToastModule.setToast({
          message: 'Restaurant has been deleted',
          timeout: 5000,
        });
        this.checkPartnerValue = true;
        this.restaurantPartners = [];
        this.partnerArr = [];
        this.profileValue.deleteProfile = '';
        this.dialog = false;
      }
    } catch (err) {
      const { error } = err.response.data;
      ToastModule.setToast({
        message: error.message,
        timeout: 5000,
      });
    }
    this.profileValue.saving = false;
  }

  public onCloseDialog() {
    this.restaurantPartners = [];
    this.dialog = false;
    this.profileValue.deleteProfile = '';
    this.partnerArr = [];
  }
}
